import { RequestTypes } from '../../../Enums';

export const getShiftCardClass = (actionType, isApproved) => {
    switch (actionType) {
        case RequestTypes.toCover:
            return 'TCShiftCard';
        case RequestTypes.shiftSwap:
            return 'SSShiftCard';
        case RequestTypes.openShift:
            return isApproved ? 'OSShiftCardApproved' : 'OSShiftCard';
        case RequestTypes.voluntaryTimeOff:
            return isApproved ? 'VTOShiftCardApproved' : 'VTOShiftCard';
        default:
            return 'employeeShiftCard';
    }
};